import { HeadMetadata } from "@hub/models/metadata/head-metadata";
import { BannerConfig } from "@hub/models/ui/banner-config";
import { Breadcrumb } from "@hub/models/ui/breadcrumb";
import { NavigationFolders } from "@hub/models/ui/navigation-folders";
import { PageConfig } from "@hub/models/ui/page-config";
import { Auth0Header } from "@hub/ui/auth0/auth0-header";
import { Breadcrumbs } from "@hub/ui/breadcrumbs/breadcrumbs";
import { LabFiltersBar } from "@hub/ui/filtering/lab-filters-bar";
import { LabFiltersModal } from "@hub/ui/filtering/lab-filters-modal";
import { LabResults } from "@hub/ui/filtering/lab-results";
import { LabsSearchBar } from "@hub/ui/filtering/labs-search-bar";
import { FoldersNav } from "@hub/ui/folders-nav";
import { ShellLayout } from "@hub/ui/layouts/shell-layout";
import React from "react";
import { HeroBanner } from "../banners/hero-banner";

interface LabsResultsPageLayoutProps {
  pageConfig: PageConfig;
  bannerConfig: BannerConfig;

  navigationFolders?: NavigationFolders;
  enableCustomSampleWidget?: boolean;
  breadcrumbs?: Breadcrumb[];
  headMetadata?: HeadMetadata;

  searchBarMessage?: string;
  isTemplate?: boolean;
}

export const LabsResultsPageLayout: React.FC<LabsResultsPageLayoutProps> = ({
  pageConfig,
  bannerConfig,
  navigationFolders,
  enableCustomSampleWidget,
  breadcrumbs,
  headMetadata,
  searchBarMessage,
  isTemplate = false,
}) => {
  return (
    <ShellLayout
      header={<Auth0Header />}
      pageConfig={pageConfig}
      headMetadata={headMetadata}
      breadcrumbs={
        breadcrumbs ? <Breadcrumbs breadcrumbs={breadcrumbs} /> : null
      }
      banner={<HeroBanner {...bannerConfig} />}
      navigationFolders={
        navigationFolders
          ? navigationFolders.folders && (
              <FoldersNav
                groupName={navigationFolders.group}
                folders={navigationFolders.folders}
              />
            )
          : null
      }
      sidebar={
        <>
          <LabsSearchBar placeholderMessage={searchBarMessage} />
          <LabFiltersBar />
        </>
      }
      document={
        <>
          <LabFiltersModal />
          <LabResults
            isTemplate={isTemplate}
            enableCustomSampleWidget={enableCustomSampleWidget}
          />
        </>
      }
    />
  );
};
